/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PressKitImageExtensionEnum {
    Jpg = 'jpg',
    Png = 'png'
}


export function PressKitImageExtensionEnumFromJSON(json: any): PressKitImageExtensionEnum {
    return PressKitImageExtensionEnumFromJSONTyped(json, false);
}

export function PressKitImageExtensionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitImageExtensionEnum {
    return json as PressKitImageExtensionEnum;
}

export function PressKitImageExtensionEnumToJSON(value?: PressKitImageExtensionEnum | null): any {
    return value as any;
}

